import * as yup from "yup"

export const schemaValidation = yup.object().shape({
  type: yup.string().required()
})